/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio User Teams API
 * Scrivio API for user team assignments.  ## Authentication All endpoints require Firebase Authentication JWT token in `Authorization: Bearer <token>` header.  ## Error Responses All error responses follow RFC 7807 Problem Details format. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ProblemDetail {
    /**
     * A URI reference that identifies the problem type
     */
    'type': string;
    /**
     * A short, human-readable summary of the problem
     */
    'title': string;
    /**
     * The HTTP status code
     */
    'status': number;
    /**
     * A human-readable explanation specific to this occurrence
     */
    'detail'?: string;
    /**
     * A URI reference that identifies the specific occurrence
     */
    'instance'?: string;
    /**
     * List of validation errors
     */
    'errors'?: Array<ProblemDetailErrorsInner>;
}
export interface ProblemDetailErrorsInner {
    'field'?: string;
    'message'?: string;
}
/**
 * A single team membership of a user. Users can have several of these.
 */
export interface UserTeamMembershipResponse {
    /**
     * Team ID
     */
    'teamId': string;
    /**
     * Team name
     */
    'teamName': string;
    /**
     * Team description
     */
    'teamDescription'?: string | null;
    /**
     * Team join timestamp in milliseconds
     */
    'joinedAt': number;
}

/**
 * UserTeamsApi - axios parameter creator
 */
export const UserTeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a single team membership (requires team.manage permission). Existing memberships are left untouched — this never replaces the user\'s other teams. Idempotent: adding a user to a team they already belong to returns the existing membership without changing `joinedAt`. 
         * @summary Add the user to a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam: async (userId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addUserToTeam', 'userId', userId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addUserToTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/users/{userId}/teams/{teamId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns every team within the current organization that the user is a member of. A user can belong to multiple teams; the memberships form an equal set with no primary team. 
         * @summary List the user\'s teams
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTeams: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserTeams', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/teams`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a single team membership (requires team.manage permission). The user\'s other team memberships are left untouched. Idempotent: removing a membership that does not exist succeeds. 
         * @summary Remove the user from a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam: async (userId: string, teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromTeam', 'userId', userId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeUserFromTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/users/{userId}/teams/{teamId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTeamsApi - functional programming interface
 */
export const UserTeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserTeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a single team membership (requires team.manage permission). Existing memberships are left untouched — this never replaces the user\'s other teams. Idempotent: adding a user to a team they already belong to returns the existing membership without changing `joinedAt`. 
         * @summary Add the user to a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserToTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTeamMembershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserToTeam(userId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTeamsApi.addUserToTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns every team within the current organization that the user is a member of. A user can belong to multiple teams; the memberships form an equal set with no primary team. 
         * @summary List the user\'s teams
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTeams(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTeamMembershipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTeams(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTeamsApi.getUserTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a single team membership (requires team.manage permission). The user\'s other team memberships are left untouched. Idempotent: removing a membership that does not exist succeeds. 
         * @summary Remove the user from a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromTeam(userId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTeamsApi.removeUserFromTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserTeamsApi - factory interface
 */
export const UserTeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserTeamsApiFp(configuration)
    return {
        /**
         * Adds a single team membership (requires team.manage permission). Existing memberships are left untouched — this never replaces the user\'s other teams. Idempotent: adding a user to a team they already belong to returns the existing membership without changing `joinedAt`. 
         * @summary Add the user to a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserTeamMembershipResponse> {
            return localVarFp.addUserToTeam(userId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns every team within the current organization that the user is a member of. A user can belong to multiple teams; the memberships form an equal set with no primary team. 
         * @summary List the user\'s teams
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTeams(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserTeamMembershipResponse>> {
            return localVarFp.getUserTeams(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a single team membership (requires team.manage permission). The user\'s other team memberships are left untouched. Idempotent: removing a membership that does not exist succeeds. 
         * @summary Remove the user from a team
         * @param {string} userId User ID
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeUserFromTeam(userId, teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserTeamsApi - object-oriented interface
 */
export class UserTeamsApi extends BaseAPI {
    /**
     * Adds a single team membership (requires team.manage permission). Existing memberships are left untouched — this never replaces the user\'s other teams. Idempotent: adding a user to a team they already belong to returns the existing membership without changing `joinedAt`. 
     * @summary Add the user to a team
     * @param {string} userId User ID
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addUserToTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig) {
        return UserTeamsApiFp(this.configuration).addUserToTeam(userId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns every team within the current organization that the user is a member of. A user can belong to multiple teams; the memberships form an equal set with no primary team. 
     * @summary List the user\'s teams
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserTeams(userId: string, options?: RawAxiosRequestConfig) {
        return UserTeamsApiFp(this.configuration).getUserTeams(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a single team membership (requires team.manage permission). The user\'s other team memberships are left untouched. Idempotent: removing a membership that does not exist succeeds. 
     * @summary Remove the user from a team
     * @param {string} userId User ID
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeUserFromTeam(userId: string, teamId: string, options?: RawAxiosRequestConfig) {
        return UserTeamsApiFp(this.configuration).removeUserFromTeam(userId, teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



